/**
 * 本期默认「怎么登录 / 怎么拉设备列表」契约（第一目标）。
 * 粘贴区只负责猜「数据怎么拆」；登录不依赖粘贴内容。
 * 样例来源：docs/mes-machinery-list-source-template.json
 */
import type { SourceShape } from '@/types/sourceAdapter'
import machineryShapeJson from '../../docs/mes-machinery-list-source-template.json'

/** 去掉文档用说明字段，得到可执行 SourceShape */
export function defaultConnectSourceShape(): SourceShape {
  const { _说明: _drop, ...rest } = machineryShapeJson as SourceShape & { _说明?: string }
  void _drop
  return structuredClone(rest) as SourceShape
}

/** 推断草稿若缺 login-token，补上默认登录（列出组织 / 试连要用） */
export function ensureLoginAuth(shape: SourceShape): SourceShape {
  if (shape.auth?.mode === 'login-token' && shape.auth.login) return shape
  const def = defaultConnectSourceShape()
  return {
    ...shape,
    auth: structuredClone(def.auth),
    // 列表路径若仍是推断占位 `/`，用默认列表路径；但保留已推断出的业务码路径，不被默认契约覆盖
    request:
      shape.request?.path && shape.request.path !== '/'
        ? shape.request
        : {
            ...structuredClone(def.request),
            successCheck: shape.request?.successCheck ?? structuredClone(def.request.successCheck),
          },
    pagination: shape.pagination?.strategy && shape.pagination.strategy !== 'none'
      ? shape.pagination
      : structuredClone(def.pagination),
  }
}
